import SectionBody from '../SectionBody/SectionBody'
import { HomeMessage, HomeMessageSection, MessageLabels, SectionView } from '../types'
import { Section, SectionCount, SectionHeader, SectionTitle } from './styled-components'

interface MessageGridSectionProps {
  section: HomeMessageSection
  title: string
  noResultsText: string
  view: SectionView
  labels: MessageLabels
  onToggle: (message: HomeMessage) => void
}

const MessageGridSection = ({ section, title, noResultsText, view, labels, onToggle }: MessageGridSectionProps) => {
  if (view.isEmpty) return null

  return (
    <Section id={`home-messages-${section}`}>
      <SectionHeader>
        <SectionTitle>{title}</SectionTitle>
        <SectionCount>{view.count}</SectionCount>
      </SectionHeader>
      <SectionBody noResultsText={noResultsText} view={view} labels={labels} onToggle={onToggle} />
    </Section>
  )
}

export default MessageGridSection
